export default __webpack_public_path__ + "static/media/menu_coin1.1c7fc072.jpg";